import { Dialog } from "primereact/dialog";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllConsolidatedInvoices,
  setIsAddToConsolidatedInvoicePopupOpen,
  setSelectedItems,
  updateConsolidatedInvoice,
} from "src/redux/slices/invoiceSlice";
import { useTranslation } from "react-i18next";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useEffect, useRef, useState } from "react";
import { Delete } from "@mui/icons-material";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { getTextValueById, toCamel } from "src/utils/helpers";
import { toast } from "react-toastify";
const AddToConsolidatedInvoicePopup = () => {
  const dispatch = useDispatch();

  interface ConsolidatedInvoice {
    invoiceId: string;
    invoiceNumber: string;
    // Add other relevant fields here
  }

  const [consolidatedInvoices, setConsolidatedInvoices] = useState<
    ConsolidatedInvoice[]
  >([]);
  const [selectedConsolidatedInvoiceId, setSelectedConsolidatedInvoiceId] =
    useState("");

  const invoiceStatusOptions = useSelector(
    (state: any) => state.lookup.invoiceStatusOptions
  );
  const { selectedItems } = useSelector((state: any) => state.invoices);
  const tableRef = useRef<DataTable<(typeof selectedItems)[0]>>(null);

  const invoiceIdTemplate = (rowData: any) => {
    return (
      <div onClick={() => handleInvoiceIdClick(rowData)}>
        {rowData.invoiceNumber}
      </div>
    );
  };

  const handleInvoiceIdClick = (rowData: any) => {};
  const isAddToConsolidatedInvoicePopupOpen = useSelector(
    (state: any) => state.invoices.isAddToConsolidatedInvoicePopupOpen
  );

  const { t } = useTranslation(["common", "invoice"]);

  const closePopup = (): void => {
    dispatch(setIsAddToConsolidatedInvoicePopupOpen(false));
  };
  function removeInvoiceHandler(rowData: any): void {
    const newSelectedItems = selectedItems.filter(
      (item: { invoiceId: any }) => item.invoiceId !== rowData.invoiceId
    );
    dispatch(setSelectedItems(newSelectedItems));
  }

  const removeButtonTemplate = (rowData: any) => {
    return (
      <Button
        label={t("remove")}
        onClick={() => removeInvoiceHandler(rowData)}
        icon={<Delete fontSize="small" />}
        className="primary-btn edit-btn danger-btn d-flex m-0 "
      />
    );
  };

  useEffect(() => {
    if (consolidatedInvoices.length) return;
    dispatch(getAllConsolidatedInvoices() as any).then(
      (response: { data: { ConsolidatedInvoiceIds: any[] } }) => {
        setConsolidatedInvoices(toCamel(response.data.ConsolidatedInvoiceIds));
      }
    );
  }, []);
  const handleInputChange = (e: any) => {
    setSelectedConsolidatedInvoiceId(e.value);
  };
  const assignToConsolidatedInvoiceHandler = async (): Promise<void> => {
    const selectedIds = selectedItems.map((item: any) => item.invoiceId);
    dispatch(
      updateConsolidatedInvoice(
        false,
        selectedConsolidatedInvoiceId,
        selectedIds
      ) as any
    ).then((response: any) => {
      toast.success(t("invoicesAddedToConsolidatedInvoice"));
    });
  };
  const paymentStatusTemplate = (rowData: any) => {
    return getTextValueById(rowData.invoiceStatus, invoiceStatusOptions, "id");
  };
  return (
    <Dialog
      visible={isAddToConsolidatedInvoicePopupOpen}
      onHide={closePopup}
      header={t("addToConsolidatedInvoice")}
      headerClassName="popup-header"
      className="maintenance-requests-details-popup add-to-consolidated-invoice-popup"
    >
      <div className="form-group mt-3 d-flex flex-row gap-4 w-80 ">
        <label htmlFor="consolidatedInvoice" className="required">
          {t("consolidatedInvoice")}
        </label>
        <Dropdown
          filter
          resetFilterOnHide
          emptyFilterMessage={t("noResultsFound")}
          emptyMessage ={t("noConsolidatedInvoices")}
          id="consolidatedInvoice"
          name="consolidatedInvoice"
          value={selectedConsolidatedInvoiceId}
          options={consolidatedInvoices}
          onChange={handleInputChange}
          optionLabel="consolidatedInvoiceNumber"
          optionValue="consolidatedInvoiceId"
          placeholder={t("selectConsolidatedInvoice")}
          className="w-45"
        />
        <Button
          label={t("add")}
          className="edit-btn primary-btn m-0 d-flex px-5 add-to-invoice-btn"
          disabled={!selectedConsolidatedInvoiceId || !selectedItems.length}
          onClick={assignToConsolidatedInvoiceHandler}
        />
      </div>
      <h5 className="mt-4">{t("selectedInvoicesToBeAdded")}</h5>
      <div className="grid-outer-wrapper">
      <div className="grid-inner-wrapper">
      <DataTable
        ref={tableRef}
        lazy
        className="view-invoice-grid  px-3 mt-3"
        value={selectedItems}
        emptyMessage={t("emptyRecords")}
        scrollable
      >
        <Column
          field="invoiceNumber"
          header={t("invoiceNo")}
          body={invoiceIdTemplate}
          className="md-col"
        ></Column>
        <Column
          field="invoiceStatus"
          header={t("invoiceStatus")}
          body={paymentStatusTemplate}
           className="md-col"
        ></Column>
        <Column field="buildingName" header={t("assignedBuilding")}
         className="lg-col"></Column>
        <Column field="dueDate" header={t("paymentDueDate")}  className="sm-col"></Column>
        <Column field="totalAmount" header={t("amount")} className="sm-col"></Column>
        <Column body={removeButtonTemplate}  className="sm-col"></Column>
      </DataTable>
      </div>
      </div>
    </Dialog>
  );
};

export default AddToConsolidatedInvoicePopup;
